import { render } from "./home.vue?vue&type=template&id=4e7b04db&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=4e7b04db&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/frontend-offical-website/master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7b04db"]])

export default __exports__